/**
 * Created by hp on 2017/6/23.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dialog} from 'react-weui'
import axios from 'axios';
import qs from 'qs'
import {browserHistory} from 'react-router'
import {renderMoney, isPC, getToken, getJsonFromUrl, AddRef, splitUrl} from '../utils';
import {Popup, TabBody} from 'react-weui'
import {
    Page,
    CoverImage,
    Preload,
    DetailTitle,
    AudioPlay,
    LabelBar,
    PageBottomText,
    Pay,
    GiftDialog2,
    FollowLiveroom,
    WKError,
    WKToShareCard,
    WKToIndex,
    SubscribeChannel,
    PopularBar,
    ReceiveCoupon
} from '../components';
import {
    ChannelDescription,
    ChannelLectureList,
    ChannelBottomNav,
    ChannelPayPanel,
    ChannelDialog,
    ChannelLiveroomBar,
    ChannelMonthGiftDialog,
    ChannelLimitPrice,
    ChannelGroupBuyList,
    ChannelGroupBuyListModal,
} from '../components/channel';
import { LectureTopLiveroomBar,LectureForm } from '../components/lecture'
import {MinaPay} from '../components/mina'
import Config from '../config';

import {WKPgyShare, WKPgyCheck, WKOperation, WKVisible, WKOwnDialog} from '../components/wk'
import {PushComponent, DeleteComponent, CouponSelected, CouponBar, DeepFocusBar, SVIPBar} from '../components/details'

import '../styles/Channel.css';
import errorImg from '../images/no-source.png'
import yhq from '../images/yhq-small.png'
import zs from '../images/zs.png'
import zb from '../images/zb.png'
import EditLecture from '../images/lecture/edit-lecture.png'
import PushLecture from '../images/lecture/push-lecture.png'
import StudentManage from '../images/lecture/student-manage.png'
import DataAna from '../images/lecture/data-ana.png'
import RelaySetting from '../images/lecture/relay-setting.png'
import Coupon from '../images/lecture/coupon.png'
import AddLecture from '../images/lecture/add-lecture.png'
import limitImg from '../images/lecture/limit.png'
import activityImg from '../images/activity/testActivity/women-channel-bar.gif'
import resellSucImg from '../images/share_finish.png'

import ChannelPageMiddleTab from './channel/ChannelPageMiddleTab'
import ChannelPageTab from '../components/wk/WKSwitchTab'
import '../css/page/ChannelPage.css'

class CoverVideo extends Component {
    render() {
        return <div className="cover-video">
            <video is
                   poster="http://1253442168.vod2.myqcloud.com/e22cd48bvodtransgzp1253442168/1a65d3859031868223201760499/coverBySnapshot/1504750217_3395033918.100_0.jpg"
                   src="http://1253442168.vod2.myqcloud.com/e22cd48bvodtransgzp1253442168/1a65d3859031868223201760499/v.f20.mp4"
                   controls="controls"
                   x-webkit-airplay="true"
                   webkit-playsinline="true"
                   playsinline="true"
                   preload="auto"/>
        </div>
    }
}


class ChannelPage extends Component {
    constructor(props) {
        super(props);
        this.isHideGroupBuy = props.location.query.st === 'channel_cps' || props.location.query.st === 'hide_group_buy'
        this.initComponent = this.initComponent.bind(this);
        this.initBottom = this.initBottom.bind(this);
        this.initCheckAutoPay = this.initCheckAutoPay.bind(this);
        this.initCheckCoupon = this.initCheckCoupon.bind(this);
        this.initMonthPayError = this.initMonthPayError.bind(this);
        this.handleRelayClick = this.handleRelayClick.bind(this);
        this.handleDiscount = this.handleDiscount.bind(this);
        this.handleShowGift = this.handleShowGift.bind(this);
        this.loadChannelInfo = this.loadChannelInfo.bind(this)
        this.state = {
            tab:0,
            tabFixed: false,
            has_bottom: false,
            //临时
            isfromResell:false,//从分销过来的蒙层
            hasRecentOrStart:[],
            point: false,
            shareRankList:[],
            backindexTop: 10,
            push_show: false,
            delete_show: false,
            isShareRank: false,
            isShowGift: false,
            isAddRef: 1,
            showNormalDialog: false,
            shareCardTop: null,
            NormalDialogBtns: [
                {
                    type: 'default',
                    label: '暂时不去',
                    onClick: () => {this.setState({showNormalDialog: false})}
                },
                {
                    type: 'primary',
                    label: '现在就去',
                    onClick: () => {location.assign('/account/coupons?auto_focus=1')}
                }
            ],
            resellDialogBtns: [
                {
                    type: 'default',
                    label: '关闭',
                    onClick: () => {this.setState({showResellSucDialog: false})}
                },
                {
                    type: 'primary',
                    label: '马上查看',
                    onClick: this.handleToLiveroom.bind(this)
                }
            ],
            //隐藏按钮
            isShowGroupNoLimitDialog: false,
            pgyRole: 1, // 1 普通 2 达人 3 大使
            pgyMoney: 0,
            pgyRatio: 0,
            isPgyInit: false,
            showResellSucDialog: false,
            myLiveroom: null,
        }
    }

    handleToLiveroom() {
        location.assign(`/liveroom/${this.state.myLiveroom.id}`)
    }

    handlePgyInit(data) {
        const {channel} = data
        const urlParams = getJsonFromUrl()
        const isFromPgy = urlParams && urlParams.st && urlParams.st.indexOf('pgy') > -1
        if (isFromPgy) {
            // 检查蒲公英会员情况，渲染右上角邀请卡入口
            WKPgyCheck.checkPGYMall(channel.id, 'channel').then((res) => {
                if (res.data.ret === 0) {
                    let {role, dist_money, dist_ratio} = res.data.data
                    this.setState({pgyRole: role, pgyMoney: dist_money, pgyRatio: dist_ratio, isPgyInit: true})
                    this.handleInitShareCard(data)
                } else {
                    this.handleInitShareCard(data)
                }
            }).catch(e => {
                this.handleInitShareCard(data)
            })
        } else {
            this.handleInitShareCard(data)
            WKPgyCheck.checkPGYMall(channel.id, 'channel').then((res) => {
                if (res.data.ret === 0) {
                    this.setState({isPgyInit: true})
                }
            })
        }
    }

    handleInitShareCard(data) {
        const {resell, channel} = data
        // init sharecard
        this.props.dispatch({
            type: 'SHARECARD_INIT',
            payload: {
                type: 'channel',
                id: channel.id,
                top: 50,
                is_resell: !!resell && ((resell.money * resell.percent / 100) > 1),
                title: resell && ((resell.money * resell.percent / 100) > 1) && '赚' + renderMoney(resell.money * resell.percent / 100)
            }
        });
    }

    handleInitShareData(data) {
        const {share_info, channel, resell, liveroom} = data

        // init sharedata
        let urlParams = getJsonFromUrl()
        // 判断分享链接
        let shareLink = share_info.share_url
        let shareArrs = splitUrl(shareLink)
        let hasInviterId = shareArrs && shareArrs.inviter_id
        // 蒲公英st
        if ((urlParams && urlParams.st && urlParams.st.indexOf('pgy') > -1) && hasInviterId) {
            shareLink = location.origin + location.pathname + `?inviter_id=${shareArrs.inviter_id}&st=${urlParams.st}`
            if (urlParams.is_from_pgy) {
                shareLink += `&is_from_pgy=${urlParams.is_from_pgy}`
            }
            if (urlParams.lfr) {
                shareLink += `&lfr=${urlParams.lfr}`
            }
            if (urlParams.nsid) {
                shareLink += `&nsid=${urlParams.nsid}`
            }
        }

        // init sharedata
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: share_info.share_title,
                desc: share_info.share_description,
                imgUrl: share_info.share_icon,
                type: share_info.share_type,
                dataUrl: share_info.share_data_url,
                link: shareLink,
                objectType: 'channel',
                objectId: channel.id,
                is_resell: !!resell,
                liveroom_id: liveroom.id
            }
        });
    }

    initComponent(data) {
        const {channel, stats_info, share_info, role, channel_access} = data;
        window.location.search.indexOf('is_resell_center')>-1 ? share_info.share_url = share_info.share_url + '&is_resell_center=True' : null;
        window.location.search.indexOf('from_svip_page')>-1 ? share_info.share_url = share_info.share_url + '&from_svip_page=1' : null;

        // init CoverImage
        this.props.dispatch({
            type: 'COMPONENT_INIT_COVER_IMAGE',
            payload: {
                height: Math.min(480, document.body.clientWidth) * 0.57,
                image: channel.cover_url,
                url: `/liveroom/${data.liveroom.id}`
            }
        });

        let isCPS = getJsonFromUrl().st === 'channel_cps'
        let isShowGift = channel.promoprice ? ((channel.need_money && !channel.is_relay) &&
            !role.is_manager && (channel.promoprice && channel.promoprice.price > 0)) : (channel.need_money && !channel.is_relay)
            && !role.is_manager && +channel.id !== 123444 && !isCPS
        this.setState({isShowGift})
        // init DetailTitle
        this.props.dispatch({
            type: 'COMPONENT_INIT_DETAIL_TITLE',
            payload: {
                has_popular: channel.is_preffered,
                discount_method: (channel.has_discount && !channel.is_relay) && this.handleDiscount,
                money: (channel.money && !channel_access.granted) ? renderMoney(channel.money) : 0,
                type: '专栏',
                title: channel.name,
                subTitle: channel.subtitle,
                leftSide: `已更新${stats_info.lecture_count}期`,
                rightSide: `${stats_info.popular}人气`,
                original_price: channel.all_lecture_money && channel.money && channel.all_lecture_money > channel.money ? renderMoney(channel.all_lecture_money) : 0,
                shouldGiftShow: isShowGift,
                GiftMethod: this.handleShowGift,
                id: channel.id
            }
        });

        // initShareData
        this.handleInitShareData(data)

        // init gift
        if (channel.need_money) {
            // 按时收费默认取第一个月的套餐价格
            let money = channel.is_cost_fix ? channel.money : channel.price_list[0].money;
            if (channel.promoprice && channel.promoprice.deadline_timestamp * 1000 > Date.now()){
                if (channel.promoprice.price && channel.promoprice.price > 0){
                    money = channel.promoprice.price
                }
            }
            this.props.dispatch({
                type: 'GIFT_RESET',
                payload: {
                    money: money,
                    payType: 'PAY_CHANNEL',
                    payProduct: 'gift_channel',
                    payProductKey: 'channel_id',
                    productId: channel.id,
                    paySuccessUrl: Config.MAIN_URL + `/liveroom/pay_success?channel_id=${channel.id}&st=pay_gift_channel`
                }
            });
        }
    }

    initBottom(data) {
        const {role, channel, channel_access} = data;
        if (role.is_manager) {
            this.setState({has_bottom: false});
        } else {
            if (channel.channel_type === 'open_channel') {
                this.setState({has_bottom: true});
            } else if (channel_access.granted) {
                this.setState({has_bottom: true});
            } else {
                this.setState({has_bottom: true});
            }
        }
    }

    initCheckCoupon(data) {
        const {channel_access, channel, role, liveroom} = data;
        if (!channel_access.granted && !role.is_manager) {
            const code = this.props.location.query.discount_code;
            const st = this.props.location.query.st
            if (code && (st !== 'channel_cps')) {
                this.props.dispatch({
                    type: 'COUPON_RECEIVE',
                    payload: {
                        code: code,
                        scope: 'channel',
                        target: channel,
                        liveroom: liveroom,
                    }
                })
            } else if (code && (st === 'channel_cps')) {
                this.props.dispatch({
                    type: 'COUPON_RECEIVE',
                    payload: {
                        code: code,
                        scope: 'cps_cash',
                        target: channel,
                        liveroom: liveroom,
                    }
                })
            }
        }
    }

    initMonthPayError(data) {
        const {role, liveroom} = data;
        const params = this.props.params;
        if (role.is_manager) {
            this.props.dispatch({
                type: 'ERROR_SHOW',
                payload: {
                    tips: '该专栏没有设置按时收费月套餐，请前往编辑页面设置。',
                    img: errorImg,
                    href: `/liveroom/edit_channel?channel_id=${params.channel_id}`,
                    btn: '立即前往'
                }
            });
        } else {
            this.props.dispatch({
                type: 'ERROR_SHOW',
                payload: {
                    tips: '糟糕！访问的页面被外星人挟持啦～，前往该直播间查看更多精彩内容。',
                    img: errorImg,
                    href: `/liveroom/${liveroom.id}`,
                    btn: '立即前往'
                }
            });
        }
    }

    initCheckAutoPay(data) {
        const {channel} = data;
        const params = getJsonFromUrl();

        if (params && parseInt(params.sp_auto_pay) === 1) {
            this.props.dispatch({
                type: 'PAY_CHANNEL',
                payload: {
                    params: {
                        product: 'pay_channel',
                        channel_id: channel.id,
                    },
                    success: () => {
                        if (params.sp_callback_url && params.sp_transaction_id) {
                            const {sp_callback_url, sp_transaction_id} = params;
                            const data = {sp_callback_url, sp_transaction_id, object_id: channel.id, type: 'channel'};
                            this.props.dispatch({
                                type: 'CHANNEL_SP_INIT',
                                payload: {spCallbackUrl: sp_callback_url, spTransactionId: sp_transaction_id}
                            });
                            axios.post(`/api/open_auth/callback `, qs.stringify(data)).then(res => {
                                if (res.data.code === 0) {
                                    window.location = Config.MAIN_URL + `/channel/${channel.id}/paysuccess${location.search}`;
                                }
                            });
                        } else {
                            window.location = Config.MAIN_URL + `/channel/${channel.id}/paysuccess${location.search}`;
                        }
                    }
                }
            })
        }
    }

    //推文需求--zxp--2017.12.6
    handleAutoPaying(data) {
        const {channel} = data;
        let {query} = this.props.location;

        if (query && parseInt(query.autopaying) === 1){
            this.AutoPlaying = setTimeout(() => {
                this.props.dispatch({
                    type: 'PAY_CHANNEL',
                    payload: {
                        params: {
                            product: 'pay_channel',
                            channel_id: channel.id
                        },
                        success: () => {
                            window.location = `/channel/${channel.id}/paysuccess${location.search}`;
                        }
                    }
                })
            }, 3000);
        }
    }

    handleRelayClick() {
        const {channel} = this.props.channel;
        if (this.state.isPgyInit) {
            axios.get('/api/account/center?version=2').then(res => {
                if (res.data.code === 0) {
                    let data = res.data.data
                    let myLiveroom = data.my_liveroom
                    if (myLiveroom) {
                        this.setState({myLiveroom})
                        WKPgyCheck.resell(myLiveroom.id, channel.id, 'channel').then(res => {
                            if (res.data.code === 0) {
                                this.setState({ showResellSucDialog: true });
                            } else if (res.data.code === -1) {
                                this.page.showAlert('不能重复添加专栏至直播间')
                            } else {
                                this.page.showAlert(res.data.msg)
                            }
                        })
                    } else {
                        location.assign(`/lecture/relay_confirm_new?id=${channel.id}&type=channel`)
                    }
                }
            })
        } else {
            location.assign(`/lecture/relay_confirm_new?id=${channel.id}&type=channel`)
        }
    }

    handleDiscount() {
        this.setState({showNormalDialog: true})
    }

    handleShowGift() {
        const isCostFix = this.props.channel.channel.is_cost_fix;

        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'new_gift_entry_channel'
        })

        if (isCostFix) {
            this.props.dispatch({type: 'GIFT_SHOW_DIALOG'})
        } else {
            this.props.dispatch({type: 'CHANNEL_SHOW_MONTH_GIFT_DIALOG'})
        }
    }

    fetchCpsData(liveroom, role) {
        let params = getJsonFromUrl()
        if (params.sid && params.st === 'channel_cps') {
            axios.get(`/api/board/is_source_id_special?sid=${params.sid}`).then(res => {
                if (res.data.code === 0) {
                    if (liveroom.id !== 23719500 && liveroom.id !== 23697056 && !role.is_manager && res.data.data.is_spec) {
                        AddRef()
                    }
                    this.setState({isAddRef: res.data.data.is_spec})
                }
            })
        } else {
            const isCps = params && (params.st === 'channel_cps' || params.lfr)
            if (liveroom.id !== 23719500 && liveroom.id !== 23697056 && !role.is_manager && !isCps) {
                AddRef()
            }
        }
    }


    loadChannelInfo() {
        let params = this.props.params;
        let urlParams = getJsonFromUrl()
        let frAccess = urlParams && urlParams.fr === 'access'

        // 加载专栏信息
        axios.get(`/api/channel/${params.channel_id}/info` + window.location.search).then(res => {
            if (res.data.code === 0) {
                let data = res.data.data;

                // 法务特例
                if (this.isLawSpecial() && !data.channel_access.granted) {
                    location.replace('/channel2/404.html')
                }

                // 判断新版分销关系，替换直播间信息
                if (data.src_liveroom) {
                    data.liveroom = data.src_liveroom
                    data.role.is_fans = data.src_liveroom.is_fans
                }

                //判断是否从超级会员专栏页进入 新加 by 姚丹
                if(/from_svip_page/.test(window.location.search)){
                    axios.get(`/api/member/is_member_goods?channel_id=${params.channel_id}`).then(res => {
                        if(res.data.code === 0){
                            data.role.is_member = res.data.data.is_member;
                            data.channel.is_member_goods = res.data.data.is_member_goods;
                            this.props.dispatch({
                                type: 'CHANNEL_INIT',
                                payload: Object.assign(data, {frAccess})
                            });
                        }
                    }).catch((error) => {
                        console.log(error)
                    });
                }else{
                    this.props.dispatch({
                        type: 'CHANNEL_INIT',
                        payload: Object.assign(data, {frAccess})
                    });
                }


                //单独获取课程授权接口 新加
                axios.get(`/api/channel/${params.channel_id}/user_channel_info`).then(res => {
                    if (res.data.code === 0) {
                        let access =  res.data.data;
                        this.props.dispatch({
                            type: 'CHANNEL_COURSE_ACCESS_INIT',
                            payload: access
                        });
                    }
                }).catch((error) => {
                    console.log(error)
                    this.props.dispatch({
                        type: 'CHANNEL_INIT',
                        payload: data
                    });
                });

                // 判断cps专栏
                this.fetchCpsData(data.liveroom, data.role)

                if (Config.REDIRECT_WARN) {
                    if (data.channel.risk_level === 'warning' && window.location.origin !== Config.WARNING_URL) {
                        let params = qs.parse(window.location.search.substr(1))
                        params.__token = getToken()
                        window.location.href = Config.WARNING_URL + window.location.pathname + '?' + qs.stringify(params)
                    }
                }
                //如果是付费或者管理员等身份直接进入课程列表
                if (data.channel_access.granted || data.channel.description === '' || data.role.is_manager || data.role.is_liveroom_vip) {
                    this.setState({tab: 1})
                    if (!data.role.is_manager) {
                        setTimeout(() => {
                            let tabElem = document.querySelector('.weui-tab')
                            if (tabElem) {
                                tabElem.scrollIntoView({
                                    behavior: 'smooth',
                                })
                            }
                        }, 500)
                    }
                } else {
                    this.setState({tab: 0})
                }

                if (data.groupbuy_info) {
                    this.fetchChannelGroupBuyList(data.groupbuy_info.id)
                }

                let channel = data.channel;
                if (channel.need_money && !channel.is_cost_fix) {
                    // 防止设置了套餐付费，但是没有设置套餐内容的情况
                    if (channel.price_list.length > 0) {
                        channel.price_list[0]["selected"] = true;
                        data.priceRecordId = channel.price_list[0].id;
                        data.priceRecordMoney = channel.price_list[0].money;
                        data.channel = channel;
                    } else {
                        // 初始化按时收费错误页面
                        this.initMonthPayError(data);
                        return;
                    }
                }

                // 是否显示价格在按钮，0或1
                if(channel.listen && !data.channel_access.granted && !sessionStorage.getItem('autoPlayIntroAudio')) {
                    sessionStorage.setItem('autoPlayIntroAudio', Math.round(Math.random()).toString())
                }

                document.title = channel.name;

                // 初始化蒲公英接口
                this.handlePgyInit(data)
                // 检查优惠券
                this.initCheckCoupon(data);
                // 初始化通用组件
                this.initComponent(data);
                // 初始化底部栏
                this.initBottom(data);

                // 检查自动支付
                if (!data.role.is_manager && !data.channel_access.granted) {
                    this.AutoPlay = setTimeout(() => {
                        this.initCheckAutoPay(data);
                    }, 1000);
                }

                if (!data.role.is_manager && !data.channel_access.granted && !data.role.is_liveroom_vip && !data.groupbuy_info) {
                    this.handleAutoPaying(data);
                }
                const routerLocation = browserHistory.getCurrentLocation();
                let params_kurisu = qs.parse(routerLocation.search.substr(1));
                if (params_kurisu.tuhaopay){
                    this.handlePayForNoCoupon();
                }
            }
        }).catch((error) => {
            if (error.response && error.response.status === 404) {
                const code = error.response.data.code
                if (code === 4041) {
                    return browserHistory.replace('/lecture/error/delete/channel')
                }
                if (code === 4042) {
                    return browserHistory.replace('/lecture/error/illegal/channel')
                }
                browserHistory.replace('/lecture/error/delete/channel')
            }
            console.log(error)
        });

    }

    handleDiscount() {
        this.setState({showNormalDialog: true})
    }

    handleShowGift() {
        const isCostFix = this.props.channel.channel.is_cost_fix;

        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'new_gift_entry_channel'
        })

        if (isCostFix) {
            this.props.dispatch({type: 'GIFT_SHOW_DIALOG'})
        } else {
            this.props.dispatch({type: 'CHANNEL_SHOW_MONTH_GIFT_DIALOG'})
        }
    }

    componentDidMount() {
        let params = this.props.params;

        if (window.location.search.indexOf('from=resell') > -1) {
            this.setState({isfromResell:true})
        }
        //如果是付费或者管理员等身份直接进入课程列表
        this.loadChannelInfo()
        this.fetchRecentAndStart()
        //是否有提示红点
        if (!localStorage.getItem('channelNew_point')) {
            this.setState({point: true});
            localStorage.setItem('channelNew_point', true)
        }

        // 请求人气榜
        axios.get(`/api/channel/${params.channel_id}/sharerank/list?limit=3`).then(res => {
            if (res.data.code === 0) {
                this.setState({isShareRank: true, shareRankList: res.data.data.list_data})
            }
        })

        this.backindex_method = () => {
            this.handleEntryAnimation();
            if (window.location.search.indexOf('is_resell_center') === -1) {
                this.handleChannelTabAnimation()
            }
        };

        window.addEventListener('scroll', this.backindex_method);
    }

    fetchChannelGroupBuyList (id) {
        axios.get(`/api/marketing/group_buy/${id}/list`)
            .then(res => {
                if (res.data.code === 0) {
                    this.props.dispatch({
                        type: 'CHANNEL_SET_GROUP_BUY_LIST',
                        payload: res.data.data.activity_list,
                    })
                }
            })
    }

    componentWillUnmount() {
        this.ShareShow && clearTimeout(this.ShareShow);
        this.AutoPlay && clearTimeout(this.AutoPlay);
        this.AutoPlaying && clearTimeout(this.AutoPlaying);
        this.ShowRealBottom && clearTimeout(this.ShowRealBottom);
        window.removeEventListener('scroll', this.backindex_method);
    }

    componentWillReceiveProps(props) {
        if (props.wechat.ready && this.isLawSpecial()) {
            window.wx.hideAllNonBaseMenuItem()
        }
    }

    handleEntryAnimation() {
        const {width} = this.props.sharecard;

        this.ShareShow && clearTimeout(this.ShareShow);

        let self = this;
        this.show_method = function () {
            self.props.dispatch({
                type: 'SHARECARD_SLIDE',
                payload: 87
            })
        };
        if (width !== 87 && !isPC()) {
            this.ShareShow = setTimeout(this.show_method, 3000);
        }

        if ((document.body.scrollTop || document.documentElement.scrollTop) > 168) {
            if (this.props.sharecard.animated) {
                if (this.props.sharecard.width !== 26) {
                    this.props.dispatch({
                        type: 'SHARECARD_SLIDE',
                        payload: 26
                    })
                }
            } else {
                return true
            }
        }
    }

    handleChannelTabAnimation() {
        if (document.querySelector('.weui-tab')){
            let height = document.querySelector('.weui-tab').offsetTop;
            if ((document.body.scrollTop) >= height || (document.documentElement.scrollTop)>=height) {
                if (!this.state.tabFixed) {
                    this.setState({
                        tabFixed: true,
                        backindexTop: 50,
                    })
                }
                if (this.props.sharecard.top === 10) {
                    this.props.dispatch({
                        type: 'SHARECARD_TOP'
                    })
                    this.setState({ shareCardTop: 50 })
                }
            } else {
                if ((document.body.scrollTop || document.documentElement.scrollTop) > 40) {
                    this.setState({ shareCardTop: '10px' })
                } else {
                    this.setState({ shareCardTop: '50px' })
                }
                if (this.state.tabFixed) {
                    this.setState({
                        tabFixed: false,
                        backindexTop: 10,
                    })
                }
                if (this.props.sharecard.top === 50) {
                    this.props.dispatch({
                        type: 'SHARECARD_RESET_TOP'
                    })
                }
            }
        }
    }

    fetchRecentAndStart() {
        let params = this.props.params;
        axios.get(`/api/channel/${params.channel_id}/recent_and_start`).then(res=>{
            if(res.status===200 && res.data.data.lectures.length>0){
             this.setState({
                 hasRecentOrStart:res.data.data.lectures
             })
            }
        })
    }

    getIsLimitPrice() {
        const {channel, role, channel_access} = this.props.channel
        if (channel && channel.promoprice) {
            if (role.is_manager) {
                return true
            }
            if (channel_access.granted) {
                return false
            }
            return true
        } else {
            return false
        }
    }
    //渲染最近学习和即将开始的判断
    renderTheMiddleTab(data){
        const {channel_access, channel, role } = data;
        //普通用户付费了
        if(!role.is_liveroom_vip && !role.is_manager ){ //非免费专栏且付费了
            if(channel.need_money && channel_access.granted){
                return (
                    <ChannelPageMiddleTab data={this.state.hasRecentOrStart}/>
                )
            }else if(!channel.need_money){ //免费专栏

                return (
                    <ChannelPageMiddleTab data={this.state.hasRecentOrStart}/>
                )
            }
        }else if(role.is_liveroom_vip){//  vip
            //如果是个免费专栏
            if(!channel.need_money){
                return (
                    <ChannelPageMiddleTab data={this.state.hasRecentOrStart}/>
                )
            }else if(channel.need_money){ //收费专栏 如果是转载并且有购买

                if(channel.is_relay && channel_access.granted){
                    return (
                        <ChannelPageMiddleTab data={this.state.hasRecentOrStart}/>
                    )
                }else if(channel.is_relay && !channel_access.granted){
                    return null
                }else if(!channel.is_relay){
                    return (
                        <ChannelPageMiddleTab data={this.state.hasRecentOrStart}/>
                    )
                }
            }
        }
    }

    handleHidePush() {
        this.setState({push_show: false})
    }

    handleHideDelete() {
        this.setState({delete_show: false})
    }

    //zxp-11.3
    handlePayForNoCoupon() {
        const routerLocation = browserHistory.getCurrentLocation();
        let params_a = qs.parse(routerLocation.search.substr(1));
        const code = params_a.discount_code;
        const {priceRecordId, discount} = this.props;
        let data = this.props.channel;
        let params = {};

        if (code){
            window.location = `/channel/${data.channel.id}?tuhaopay=1`
        }else {
            if (priceRecordId > 0) {
                params = {
                    product: 'pay_channel',
                    channel_id: data.channel.id,
                    price_record_id: priceRecordId,
                };
            } else {
                params = {
                    product: 'pay_channel',
                    channel_id: data.channel.id
                }
            }
            this.props.dispatch({
                type: 'PAY_CHANNEL',
                payload: {
                    params: params,
                    success: () => {
                        window.location = `/channel/${data.channel.id}/paysuccess${location.search}`;
                    }
                }
            });
            this.props.dispatch({
                type: 'COUPON_SELECT_HIDE'
            });
            this.props.dispatch({
                type: 'CHANNEL_HIDE_PAY_PANEL'
            });
        }
    }

    // 法务特例
    isLawSpecial() {
        let params = this.props.params;
        if (params.channel_id == '281352') {
            return true
        }
        return false
    }

    renderEditList() {
        let data = this.props.channel;
        return [
            {
                blockContent: {
                    img: DataAna,
                    text: '数据分析',
                    method: () => {
                        location.assign(`/channel/${data.channel.id}/analysis`)
                    }
                },
                hasContent: true
            },
            {
                blockContent: {
                    img: EditLecture,
                    text: '专栏编辑',
                    method: () => {
                        location.assign(`/channel/${data.channel.id}/edit`)
                    }
                },
                hasContent: !data.channel.is_relay
            },
            {
                blockContent: {
                    img: PushLecture,
                    text: '专栏推送',
                    method: () => {
                        this.setState({
                            push_show: true
                        })
                    }
                },
                hasContent: true
            },
            {
                blockContent: {
                    img: AddLecture,
                    text: '添加课程',
                    method: () => {
                        location.assign(`/liveroom/${data.liveroom.id}/lecture/create?channel_id=${data.channel.id}`)
                    }
                },
                hasContent: !data.channel.is_relay,
            },
            {
                blockContent: {
                    img: StudentManage,
                    text: '学员管理',
                    method: () => {
                        location.assign(`/channel/${data.channel.id}/listeners`)
                    }
                },
                hasContent: !data.channel.is_relay && data.channel.need_money
            },
            {
                blockContent: {
                    img: Coupon,
                    text: '优惠券',
                    method: () => {
                        location.assign(`/liveroom/${data.liveroom.id}/coupon/list?scope=channel&channel_id=${data.channel.id}`)
                    }
                },
                hasContent: !data.channel.is_relay && data.channel.need_money
            },
            {
                blockContent: {
                    img: limitImg,
                    text: '限时特价',
                    method: () => {
                        if (data.groupbuy_info) {
                            this.setState({ isShowGroupNoLimitDialog: true })
                        } else {
                            location.assign(`/channel/${data.channel.id}/edit/limit`)
                        }
                    }
                },
                hasContent: !data.channel.is_relay && data.channel.need_money && data.channel.is_cost_fix
            },
            {
                blockContent: {
                    img: RelaySetting,
                    text: '转载设置',
                    method: () => {
                        location.assign(`/relay_setting/channel/${data.channel.id}`)
                    }
                },
                hasContent: !data.channel.is_relay
            }
        ]
    }
    setTabIndex(val) {
        this.setState({tab:val})
    }

    render() {
        const {
            initialized, channel, role, showPayPanel, channel_access, liveroom,
            groupbuy_info, isShowGroupBuyListModal, channelGroupBuyList
        } = this.props.channel;
        const {tabFixed, has_bottom, backindexTop} = this.state;
        const limitPrice = channel && channel.promoprice
        // 是否显示限时特价
        const isLimitPrice = this.getIsLimitPrice();
        const urlParams = getJsonFromUrl();
        const isPresentPage = urlParams && urlParams.isPresent
        const isPgy = WKPgyCheck.isFromPgy
        const isShowActivityCard = channel && channel.id === 84657 && !urlParams.isActive
        const isCoupon = !isShowActivityCard && this.props.newCoupon.hasCoupon && (channel && channel.need_money) && !role.is_manager
            && !role.is_liveroom_vip && !channel_access.granted && channel.channel_type === 'pay_channel'
        // 小程序支付参数分离
        const {wk_pay_source, mina_type, product, mina_product_id, inviter_id, st, sid, mina_discount_id} = urlParams
        const {error} = this.props;
        if (error.showError) {
            return (
                <div className="lecture-page">
                    <WKError/>
                </div>
            )
        }

        if (!initialized) {
            return <Page parent={this}>
                <div className="wk-inner-page main-page">
                    <Preload/>
                </div>
            </Page>
        }

        let isChannelCps = urlParams && (urlParams.lfr || urlParams.st === 'channel_cps') && urlParams.nsid !== 'pgy'
        let showRelay = ((!channel.is_relay && channel.can_public_relay) || (this.state.isPgyInit && !groupbuy_info)) && !role.is_manager
        let showToIndex = !isPresentPage && this.state.isAddRef === 1 && !isChannelCps
        let showFollowBar = !isPresentPage && !isChannelCps

        return (
            <Page>
                {this.state.isfromResell?
                    <div className="resell-from">
                        <div className="resell-mockup" >
                            <img onClick={()=>this.setState({isfromResell: false})} src={require('../images/activity/resell-marker@3x.png')} alt=""/>
                        </div>
                    </div>
                    : null}
                <Popup show={this.state.isfromResell} onRequestClose={e=>this.setState({isfromResell: false})}/>
                <Dialog type="ios" buttons={this.state.NormalDialogBtns} show={this.state.showNormalDialog}>
                    点击"个人中心-优惠券"能更快捷进入"我的优惠券"页面填写优惠码哦
                </Dialog>
                <Dialog type="ios" buttons={this.state.resellDialogBtns} show={this.state.showResellSucDialog}>
                    <div>
                        <img src={resellSucImg} style={{width: '60px'}}/>
                        <p style={{margin: '15px 0 10px'}}>转载成功</p>
                        <p style={{fontSize: '14px', color: '#666'}}>该专栏已成功转载到你的直播间</p>
                    </div>
                </Dialog>
                <div className={has_bottom ? 'channel-page-padding' : ''}>
                    <div className="channel-page">
                        {!(channel_access.granted || role.is_manager) &&
                        <MinaPay discountId={mina_discount_id} paySource={wk_pay_source} minaType={mina_type} product={product} id={mina_product_id} inviterId={inviter_id} st={st} sid={sid}/>
                        }

                        {this.props.showSubscribeChannel &&
                        <SubscribeChannel/>
                        }

                        <FollowLiveroom/>

                        {showToIndex &&
                        <WKToIndex top={backindexTop} />
                        }

                        {(!groupbuy_info && isPgy && this.state.isPgyInit) ?
                            <WKPgyShare
                                top={this.state.shareCardTop}
                                role={this.state.pgyRole}
                                id={channel.id}
                                ratio={this.state.pgyRatio}
                                money={this.state.pgyMoney}/>
                            :
                            !isPresentPage && !isChannelCps && !this.isLawSpecial() &&
                            <WKToShareCard top={this.state.shareCardTop} />
                        }

                        {channel.need_money && !channel.is_cost_fix &&
                        <ChannelMonthGiftDialog/>
                        }

                        <GiftDialog2/>

                        <Pay/>

                        {showPayPanel &&
                        <ChannelPayPanel location={this.props.location}/>
                        }

                        <ChannelDialog/>

                        <LectureTopLiveroomBar type='channel' />

                        {channel.id === 62436 ?
                            <CoverVideo/>
                            :
                            <CoverImage/>
                        }

                        {/* 拼团倒计时 */}
                        {
                            groupbuy_info && !this.isHideGroupBuy && (role.is_manager || !channel_access.granted) && (
                                <ChannelLimitPrice
                                    channel={channel}
                                    type='channelGroupBuy'
                                    groupBuy={groupbuy_info}
                                />
                            )
                        }

                        {isLimitPrice &&
                        <ChannelLimitPrice channel={channel}/>
                        }

                        <DetailTitle complainType="channel" groupBuy={groupbuy_info} isHideGroupBuy={this.isHideGroupBuy} limitPrice={limitPrice}/>

                        {/*优惠券tab*/}
                        { isCoupon && !isPgy &&
                        <CouponBar type="channel" target_id={channel.id} />
                        }

                        {/*判断渲染最近学习和即将开始*/}
                        {this.renderTheMiddleTab(this.props.channel)}

                        {(!role.is_manager && channel.is_member_goods && /from_svip_page/.test(window.location.search)) && !channel_access.granted &&
                        <SVIPBar isCoupon={isCoupon} content={channel} role={role} type="channel"/>
                        }

                        {channel.need_money && !role.is_manager && !role.is_liveroom_vip &&
                        !channel_access.granted && channel.channel_type === 'pay_channel' &&
                        !isPgy&&
                        <CouponSelected type="channel" st={st} source_type={channel_access.source_type} target_id={channel.id} payMethod={() => this.handlePayForNoCoupon()} />
                        }

                        {channel.has_discount && !isPgy &&
                        <ReceiveCoupon/>
                        }

                        {isShowActivityCard &&
                        <div className="channel-card" style={{margin: "10px 0"}} onClick={e =>{
                            location.assign(`/specials/activity/test`)
                            this.props.dispatch({
                                type: 'MTA_CLICK',
                                payload: `women_to_test_page`
                            })
                        }}>
                            <img src={activityImg} alt='' />
                        </div>
                        }

                        {/* 正在拼团列表 */}
                        {
                            channelGroupBuyList.length > 0 && !this.isHideGroupBuy && (role.is_manager || !channel_access.granted) && (
                                <ChannelGroupBuyList channelGroupBuyList={channelGroupBuyList} />
                            )
                        }

                        {
                            isShowGroupBuyListModal && (
                                <ChannelGroupBuyListModal groupId={groupbuy_info && groupbuy_info.id} />
                            )
                        }

                        {/* tab */}
                        <ChannelPageTab tabFixed={tabFixed} tabName={['详情','目录']} setTabIndex={val=>this.setTabIndex(val)} isSelectIndex={this.state.tab}/>
                        <TabBody>
                            <WKVisible create={this.state.tab === 0}>
                                <div>
                                    {channel.is_preffered &&
                                    <PopularBar prefferedReason={channel.preffered_reason}/>
                                    }

                                    {channel.listen !== '' &&
                                    <AudioPlay audioUrl={channel.listen} title={channel.name}
                                               account_id={role.account_id} type={'channel'} obj_id={channel.id}/>
                                    }
                                    <ChannelDescription/>
                                    <LabelBar labelClassName="no-margin " onCellClick={() => {
                                        this.setState({tab: 1});
                                        document.body.scrollTop = document.querySelector('.weui-tab').offsetTop;
                                    }}>
                                        查看此专栏课程
                                    </LabelBar>
                                    {!this.isLawSpecial() &&
                                    <LabelBar labelClassName="no-margin channel-share-rank "
                                        onCellClick={() => {window.location = `/channel/${channel.id}/sharerank`}}
                                        labelFoot={
                                            this.state.shareRankList.slice(0, 3).map((rank) => {
                                                return (
                                                    <span className="portrait" key={rank.id}>
                                                    <img src={rank.avatar} alt={rank.name}/>
                                                </span>
                                                )
                                            })
                                        }>
                                        人气榜
                                    </LabelBar>
                                    }
                                </div>
                            </WKVisible>

                            <WKVisible create={this.state.tab === 1}>
                                <div>
                                    <ChannelLectureList/>
                                </div>
                            </WKVisible>
                        </TabBody>

                        <div className="channel-labelbar">
                            {channel.has_discount && !channel.is_relay && !role.is_manager && !channel_access.granted && !isPresentPage && false &&
                            <LabelBar labelClassName='no-margin has-border ' onCellClick={this.handleDiscount}>
                                <div className="label-bar-icon-image">
                                    <img src={yhq} alt="优惠券通道"/>
                                </div>
                                优惠码通道
                            </LabelBar>
                            }

                            {showRelay && !this.isLawSpecial() &&
                            <LabelBar labelClassName={!channel.has_discount ? 'no-margin has-border ' : 'no-margin '}
                                      onCellClick={this.handleRelayClick}>
                                <div className="label-bar-icon-image">
                                    <img src={zb} alt="我要转载"/>
                                </div>
                                我要转载
                            </LabelBar>
                            }

                            {this.state.isShowGift && !isChannelCps && !this.isLawSpecial() &&
                            <LabelBar labelClassName={'no-margin '} onCellClick={this.handleShowGift}>
                                <div className="label-bar-icon-image">
                                    <img className="label-bar-icon-image" src={zs} alt="赠送好友"/>
                                </div>
                                赠送好友
                            </LabelBar>
                            }
                        </div>

                        <LectureForm channelId={channel.id}/>

                        {(role.is_manager || role.is_relayer) &&
                        <div>
                            {this.state.push_show &&
                            <PushComponent type={'channel'} target_id={channel.id}
                                           handleHidePush={() => this.handleHidePush()}/>
                            }
                            {this.state.delete_show &&
                            <DeleteComponent type={'channel'} target_id={channel.id} liveroom_id={liveroom.id}
                                             handleHideDelete={() => this.handleHideDelete()}/>
                            }
                            <WKOperation editList={this.renderEditList()}/>
                        </div>
                        }

                        <ChannelLiveroomBar isPresentPage={isPresentPage}/>

                        {showFollowBar &&
                        <DeepFocusBar liveroom_id={liveroom.id} object_id={channel.id} object_type="fl_channel"/>
                        }

                        <PageBottomText type='channel' id={channel.id}/>
                    </div>
                </div>

                {has_bottom &&
                <ChannelBottomNav/>
                }

                <WKOwnDialog type="ios" title='' buttons={[
                    { label: '知道了', onClick: () => this.setState({ isShowGroupNoLimitDialog: false }) }
                ]} show={this.state.isShowGroupNoLimitDialog}>
                    此专栏处于拼团活动期间，不可设置限时特价
                </WKOwnDialog>
            </Page>
        )
    }
}

ChannelPage.childContextTypes = {
    channelPage: React.PropTypes.object
};

export default connect((state) => ({
    wechat: state.wechat,
    channel: state.channel,
    error: state.error,
    sharecard: state.sharecard,
    account: state.account,
    discount: state.channel.discount,
    priceRecordId: state.channel.priceRecordId,
    newCoupon: state.newCoupon,
    showSubscribeChannel: state.subscribeChannel.showSubscribeChannel,
}))(ChannelPage)



// WEBPACK FOOTER //
// ./src/pages/ChannelPage.js